import { useLocation } from 'react-router-dom';

// The staff-side portals share the same components mounted under different route
// bases: '/staff' (UK → Spain), '/es' (Spain → UK) and '/pad' (Padelante padel).
// This hook returns the base the component is currently rendered under, so shared
// components can build internal links (`${base}/requests/${id}`) that keep the
// user inside the portal they're actually in rather than jumping across.
export default function useBasePath() {
  const { pathname } = useLocation();
  if (pathname.startsWith('/es')) return '/es';
  if (pathname.startsWith('/pad')) return '/pad';
  return '/staff';
}
